"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _get = _interopRequireDefault(require("lodash/get"));

var _runtimeConfigHelper = _interopRequireDefault(require("./runtime-config-helper"));

/**
 * Get the api key
 *
 * @class ApiKeyHelper
 */
var ApiKeyHelper =
/*#__PURE__*/
function () {
  function ApiKeyHelper() {
    (0, _classCallCheck2["default"])(this, ApiKeyHelper);
  }

  (0, _createClass2["default"])(ApiKeyHelper, null, [{
    key: "getApiKey",

    /**
     * Get the api key from the givin name and the current env
     *
     * @static
     * @param {string} name
     * @returns {string} apikey
     *
     * @memberOf ApiKeyHelper
     */
    value: function getApiKey(name) {
      return (0, _get["default"])(_runtimeConfigHelper["default"].getRuntimeConfig()._apiKeys, "".concat(name));
    }
  }]);
  return ApiKeyHelper;
}();

var _default = ApiKeyHelper;
exports["default"] = _default;